<template>
    <div class="a-you-are-here you-are-here">
        <svg-icon
            class="you-are-here__icon"
            original
            name="guide-graphics/you-are-here"
        />
        <span class="you-are-here__text" v-html="$t('a-you-are-here')" ></span>
    </div>
</template>

<script>
export default {
    name: 'AYouAreHere'
}
</script>

<style lang="scss">
@import "a-you-are-here";
</style>